import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
/**
 * Formats an ISO8601 timestamp for the sync-status rows, tiered to match the
 * IP-13778 designs:
 * - within the last hour → relative ("2 minutes ago")
 * - earlier today        → "today, 9:02 AM"
 * - this year            → "Jun 9, 4:12 PM"
 * - older                → "Jun 9, 2024, 4:12 PM"
 *
 * The `todayLabel` is injected by callers (via i18n) so the same-day case is
 * localized rather than hard-coded English.
 *
 * @example formatRelativeTime('2025-06-01T10:00:00Z', 'today') → 'Jun 1, 10:00 AM'
 */
export function formatRelativeTime(isoString, todayLabel) {
    const date = dayjs(isoString);
    const now = dayjs();
    if (now.diff(date, 'minute') < 60)
        return date.fromNow();
    if (date.isSame(now, 'day'))
        return `${todayLabel}, ${date.format('h:mm A')}`;
    if (date.isSame(now, 'year'))
        return date.format('MMM D, h:mm A');
    return date.format('MMM D, YYYY, h:mm A');
}
/**
 * Absolute timestamp for the error-banner meta line, e.g. "Jun 10, 9:14 AM"
 * (year appended only when it differs from the current year).
 */
export function formatAbsoluteTime(isoString) {
    const date = dayjs(isoString);
    if (date.isSame(dayjs(), 'year'))
        return date.format('MMM D, h:mm A');
    return date.format('MMM D, YYYY, h:mm A');
}
